import { responseSchema } from './response-schema';
export var makeRequestConfig = function (_a) {
    var endpoint = _a.endpoint, browserCacheParams = _a.browserCacheParams;
    return {
        endpoint: endpoint,
        responseSchema: responseSchema,
        isErrorTextStraightToOutput: true,
        browserCacheParams: browserCacheParams,
        pureJsonFileResponse: true,
        cache: 'no-store',
    };
};
